import { operationInProgress } from '../action/profile.action'
import ActionType from '../action.types'
import serviceInterface from '../../services/service.interface'
import { message } from 'antd'

/*
Actions to be dispatched for signin
- surgeon list
    Get surgeon information for given company
- service error
*/
export function serviceError(bool, message) {
  return {
    type: ActionType.SURGEON_ERROR,
    hasError: bool,
    message,
    isLoading: false,
  }
}

export function setSurgeon(surgeon) {
  return {
    type: ActionType.SET_SURGEON,
    surgeon,
    isLoading: false,
  }
}

export function surgeonList(surgeons) {
  return {
    type: ActionType.SURGEON_LIST,
    surgeons,
    isLoading: false,
  }
}

export function setSelectedSurgeons(selectedSurgeons) {
  return {
    type: ActionType.SURGEON_SELECT,
    selectedSurgeons,
  }
}

export function surgeonsPagination({
  surgeons,
  pagination,
  sorter,
  searchText,
}) {
  return {
    type: ActionType.SURGEONS,
    pageSurgeons: surgeons,
    pagination,
    sorter,
    searchText,
    isLoading: false,
  }
}

export function getSurgeonList(customerid) {
  return async (dispatch) => {
    try {
      dispatch(operationInProgress(true))
      var data = await serviceInterface
        .SurgeonService()
        .getSurgeonList(customerid)
      dispatch(operationInProgress(false))
      if (data.error) dispatch(serviceError(true, data.message))
      else dispatch(surgeonList(data.surgeons))
    } catch (err) {
      dispatch(operationInProgress(false))
      dispatch(serviceError(true, 'error communicating with the server'))
    }
  }
}

export function fetchSurgeons(params) {
  return async (dispatch) => {
    try {
      dispatch(operationInProgress(true))
      var data = await serviceInterface.SurgeonService().getSurgeons(params)
      dispatch(operationInProgress(false))
      if (data.error) {
        dispatch(serviceError(true, data.message))
      } else {
        data = { ...data, ...params }
        data.pagination.total = data.total
        dispatch(surgeonsPagination(data))
      }
    } catch (err) {
      console.log(err)
      dispatch(operationInProgress(false))
      dispatch(serviceError(true, 'error communicating with the server'))
    }
  }
}

export function getAccessCode() {
  return async (dispatch) => {
    try {
      dispatch(operationInProgress(true))
      var data = await serviceInterface.SurgeonService().getAccessCode()
      dispatch(operationInProgress(false))
      return data
    } catch (err) {
      console.log(err)
      dispatch(operationInProgress(false))
      dispatch(serviceError(true, 'error communicating with the server'))
    }
  }
}

export function onSurgeonSelect(params) {
  return async (dispatch) => {
    try {
      var surgeons = serviceInterface.SurgeonService().onSurgeonSelect(params)
      dispatch(setSelectedSurgeons(surgeons))
    } catch (err) {
      console.log(err)
    }
  }
}

export function addEditSurgeon(params, id) {
  return async (dispatch) => {
    try {
      dispatch(operationInProgress(true))
      var data = await serviceInterface
        .SurgeonService()
        .addEditSurgeon(params, id)
      dispatch(operationInProgress(false))
      if (data.error) {
        message.error(data.message)
        return false
      } else {
        message.success(data.message)
        return data
      }
    } catch (err) {
      console.log(err)
      dispatch(operationInProgress(false))
      dispatch(serviceError(true, 'error communicating with the server'))
    }
  }
}

export function removeSurgeons(params) {
  return async (dispatch) => {
    try {
      dispatch(operationInProgress(true))
      var data = await serviceInterface.SurgeonService().removeSurgeons(params)
      dispatch(operationInProgress(false))
      if (data.error) {
        message.error(data.message)
        return false
      } else {
        message.success(data.message)
        return data
      }
    } catch (err) {
      console.log(err)
      dispatch(operationInProgress(false))
      dispatch(serviceError(true, 'error communicating with the server'))
    }
  }
}

export function getSurgeon(id, return_raw = false) {
  return async (dispatch) => {
    try {
      dispatch(operationInProgress(true))
      var data = await serviceInterface.SurgeonService().getSurgeon(id)
      dispatch(operationInProgress(false))
      if (data.error) {
        message.error(data.message)
        return false
      } else {
        if (return_raw) return data
        else {
          dispatch(setSurgeon(data))
          return data
        }
      }
    } catch (err) {
      console.log(err)
      dispatch(operationInProgress(false))
      dispatch(serviceError(true, 'error communicating with the server'))
    }
  }
}
export function verifyActivityLinkOtp(input) {
  return async (dispatch) => {
    try {
      dispatch(operationInProgress(true))
      var data = await serviceInterface
        .AuthService()
        .verifyActivityLinkOtp(input)
      dispatch(operationInProgress(false))
      if (data.error) {
        message.error(data.message)
        return false
      } else {
        message.success(data.message)
        return data
      }
    } catch (err) {
      console.log(err)
      dispatch(operationInProgress(false))
      dispatch(serviceError(true, 'error communicating with the server'))
    }
  }
}

export function validPatientId(input) {
  return async (dispatch) => {
    try {
      dispatch(operationInProgress(true))
      var data = await serviceInterface.AuthService().validPatientId(input)
      dispatch(operationInProgress(false))
      if (data.error) {
        message.error(data.message)
        return false
      } else {
        message.success(data.message)
        return data
      }
    } catch (err) {
      console.log(err)
      dispatch(operationInProgress(false))
      dispatch(serviceError(true, 'error communicating with the server'))
    }
  }
}
